import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * 3-Phase Power Meter Icon Style 02 - Bolt
 * Lightning bolt icon representing electrical power
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:bolt
 */
export const Style02_Bolt: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-blue-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      bolt
    </span>
  );
};

export default Style02_Bolt;
